var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('span',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("×")]),_c('pre',[_vm._v(_vm._s(_vm.formattedJson))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }